module.exports = __webpack_public_path__ + "img/Spotify_logo_full_black.1f61ed6f.png";